/** One detail row inside the expanded item panel; renders nothing when empty. */
export function DetailRow({ label, value }: { label: string; value?: string }) {
  if (!value) return null
  return (
    <div className='ramp-scan-detail'>
      <span className='ramp-scan-detail-label'>{label}</span>
      <span className='ramp-scan-detail-value'>{value}</span>
    </div>
  )
}
